import React, { ReactElement } from "react"
import StyledSelect from "./StyledSelect"
import { CompanyOption } from "types/data-visualization.types"

interface CompanySelectProps {
  value?: CompanyOption
  onChange: (value: CompanyOption | undefined) => void
  placeholder?: string
  label?: string
  required?: boolean
  width?: string
  height?: string
  disabled?: boolean
  options: CompanyOption[]
}

export default function CompanySelect({
  value,
  onChange,
  placeholder = "Sélectionnez une entreprise",
  label,
  required = false,
  width,
  height,
  disabled = false,
  options,
}: CompanySelectProps): ReactElement {
  const handleChange = (selectedValue: string) => {
    if (selectedValue === "") {
      onChange(undefined)
    } else {
      const selectedOption = options.find(company => company.value === selectedValue)
      onChange(selectedOption)
    }
  }

  // Convert CompanyOption to StyledSelect format
  const selectOptions = options.map(company => ({
    value: company.value,
    text: company.label,
  }))

  return (
    <StyledSelect
      options={selectOptions}
      value={value?.value || ""}
      onChange={handleChange}
      placeholder={placeholder}
      label={label}
      required={required}
      width={width}
      height={height}
      disabled={disabled}
      clearable
    />
  )
}
